export default (element, handler) => {
  const observer = new ResizeObserver(handler);
  observer.observe(element);

  return observer;
};
